import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { FiCalendar, FiSettings } from "react-icons/fi";

export default function TicketStatus() {
  const [range, setRange] = useState("Monthly");
  const [open, setOpen] = useState(false);

  const dataSets = {
    Today: [300, 150, 80, 40],
    Weekly: [500, 250, 120, 60],
    Monthly: [653, 342, 185, 67],
  };

  const data = dataSets[range];
  const total = data.reduce((a, b) => a + b, 0);

  const max = Math.max(...data);

  return (
    <Card  className="h-100" style={styles.card}>
      <Card.Body>

        {/* HEADER */}
        <div style={styles.header}>
          <h5 style={styles.title}>Tickets By Status</h5>

          <div style={{ display: "flex", gap: 8 }}>
            {/* DROPDOWN */}
            <div style={{ position: "relative" }}>
              <button
                style={styles.dropdownBtn}
                onClick={() => setOpen(!open)}
              >
                <FiCalendar size={14} /> {range}
              </button>

              {open && (
                <div style={styles.dropdown}>
                  {["Today", "Weekly", "Monthly"].map((item) => (
                    <div
                      key={item}
                      style={styles.dropdownItem}
                      onClick={() => {
                        setRange(item);
                        setOpen(false);
                      }}
                    >
                      {item}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* SETTINGS ICON */}
            {/* <div style={styles.settingBtn}>
              <FiSettings />
            </div> */}
          </div>
        </div>

        <div style={styles.content}>

          {/* SVG GRAPH */}
          <div style={styles.chartWrap}>
            <svg viewBox="0 0 200 200" style={{ width: 220 }}>

              {data.map((value, i) => {
                const radius = 80 - i * 15;
                const circumference = 2 * Math.PI * radius;
                const progress = (value / max) * circumference;

                return (
                  <g key={i} transform="rotate(-90 100 100)">
                    
                    {/* TRACK */}
                    <circle
                      cx="100"
                      cy="100"
                      r={radius}
                      fill="none"
                      stroke="#e5e7eb"
                      strokeWidth="14"
                    />

                    {/* PROGRESS */}
                    <circle
                      cx="100"
                      cy="100"
                      r={radius}
                      fill="none"
                      stroke={colors[i]}
                      strokeWidth="14"
                      strokeDasharray={circumference}
                      strokeDashoffset={circumference - progress}
                      strokeLinecap="round"
                    />
                  </g>
                );
              })}
            </svg>
          </div>

          {/* RIGHT SIDE */}
          <div style={styles.details}>

            <div style={styles.totalRow}>
              <span>Total Tickets</span>
              <h3>{total}</h3>
            </div>

            {labels.map((label, i) => (
              <div key={i} style={styles.row}>
                <span style={styles.label}>
                  <span
                    style={{
                      ...styles.dot,
                      background: colors[i],
                    }}
                  />
                  {label}
                </span>
                <b>{data[i]}</b>
              </div>
            ))}
          </div>

        </div>
      </Card.Body>
    </Card>
  );
}

/* COLORS EXACT */
const colors = ["#f97316", "#3b82f6", "#facc15", "#a855f7"];
const labels = ["Open", "In Progress", "On Hold", "Closed"];

/* STYLES */
const styles = {
  card: {
    borderRadius: 5,
    border: "2px solid #eee",

  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 20,
  },

  title: {
    fontWeight: 600,
  },

  dropdownBtn: {
    border: "1px solid #e5e7eb",
    padding: "6px 10px",
    borderRadius: 8,
    background: "#fff",
    display: "flex",
    alignItems: "center",
    gap: 5,
    fontSize: 13,
  },

  dropdown: {
    position: "absolute",
    top: 40,
    right: 0,
    background: "#fff",
    borderRadius: 12,
    boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
    overflow: "hidden",
  },

  dropdownItem: {
    padding: "10px 16px",
    cursor: "pointer",
  },

  settingBtn: {
    background: "#f97316",
    color: "#fff",
    padding: 8,
    borderRadius: 8,
  },

  content: {
    display: "flex",
    flexWrap: "wrap",
    gap: 20,
    alignItems: "center",
  },

  chartWrap: {
    flex: 1,
    textAlign: "center",
  },

  details: {
    flex: 1,
  },

  totalRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 10,
  },

  row: {
    display: "flex",
    justifyContent: "space-between",
    background: "#f9fafb",
    padding: "10px 14px",
    borderRadius: 20,
    marginBottom: 10,
  },

  label: {
    display: "flex",
    alignItems: "center",
    gap: 6,
  },

  dot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
  },
};